import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(app)/guess-the-goal/page.tsx");
